export default "__VITE_ASSET__DbfR3Gxb__"